/* The free-entry count, in words — every sentence in this funnel that states it.
 *
 * The number is no longer one figure for every poster. Each code carries its own
 * amount, so the same page can be asked to print 1 or 10, and a template that
 * only ever said "entries" would print "Claim 1 free entries". The singular or
 * plural is chosen here, once, for all three sentences.
 *
 * Only the forms WITH a number live here. When there is no number to state — the
 * request failed, or the confirmation page has no code to ask with — each page
 * keeps its own generic line ("Claim your free entries", "Your entries are
 * reserved") rather than print a figure it cannot tie to a code.
 */

/** "Claim 10 free entries", "Claim my 10 entries", "10 entries are reserved" —
 * and the singular of each for exactly one. */
export const freeEntriesCopy = (entries: number) => {
  const one = entries === 1;
  return {
    /* The offer page's headline. */
    claim: `Claim ${entries} free ${one ? 'entry' : 'entries'}`,
    /* The offer page's submit button. */
    claimMy: `Claim my ${entries} ${one ? 'entry' : 'entries'}`,
    /* The confirmation page's headline. */
    reserved: `${entries} ${one ? 'entry is' : 'entries are'} reserved`
  };
};
